import {
  PDF_CONTENT_MARGIN,
  SIDE_PANEL_WIDTH,
} from '../../client/constants';
import getPdfViewerApplication from '../../client/utils/pdfjs/pdfViewerApplication';

/**
 * return a pdf scale for fitToWidth according to isSidePanelOpen
 *
 * @param isSidePanelOpen {Boolean}
 * @return {number} - pdf scale for fitToWidth
 */
export function getFitToWidthPdfScale(isSidePanelOpen) {
  const clientPageWidth = isSidePanelOpen
    ? window.innerWidth - PDF_CONTENT_MARGIN - SIDE_PANEL_WIDTH
    : window.innerWidth - PDF_CONTENT_MARGIN;

  return clientPageWidth / getPdfViewerApplication().getCurrentPageWidth();
}
